
function Now() {
    return (
        <>  
            <div className='middle-column container-body-width'>
                <div className='blue-bubble who-am-i'>
                    <h1 className='blue-league-title'>Oct 22, '26</h1>
                    <p className='gray-league-paragraph-large'>
                        We're back to itch piloting, and I'm calling my current unemployment status a "creative sabbatical". Sleeper laid off a handful of people recently, myself one of them.<br></br>

                        I haven't felt much of a spark with programming lately, so I decided I'm going to take (at least) two months to work on my own endeavors.<br></br>

                        This weekend, I'm at Lightbox and just one evening in I feel like I've found the people I need to surround myself with more often.<br></br>
                    </p>
                </div>
                <div className='blue-bubble who-am-i'>
                    <h1 className='blue-league-title'>July 5, '26</h1>
                    <p className='gray-league-paragraph-large'>
                        I've just organized some thoughts and feeling more confident finding what I want going forward. Amongst existential angst wondering if I should go back to school for nursing or teaching, I'm realizing I want to spend my living and breathing time creating. Not consuming.<br></br>

                        I want to help people, live independently, to express myself, and to lead a community that's at the center of it all.<br></br>

                        I've been reading <i>That Will Never Work</i> which is about the founding of Netflix, and ultimately I do really want to make my own thing. I just need to continue believing I can do so.<br></br>

                        I've been going to jiu jitsu 8x a week, often twice a day- though at the sacrifice of my morning game development. Moving forward with a "no zero days" policy on that, just to touch things up. Making sure that I'm not blind to the next opportunity when it matters the most.<br></br>

                        And of course, continue itch piloting.
                    </p>
                </div>
                <div className='blue-bubble who-am-i'>
                    <h1 className='blue-league-title'>May 19, '26</h1>
                    <p className='gray-league-paragraph-large'>
                        I've just finished <i>Anything You Want</i> by <a className='league-p-clickable' href="https://sive.rs/a">Derek Sivers</a> and was encouraged to: <br></br>
                        <ul>
                            <li>- Resume mockups for Project Harbinger </li>
                            <li>- File for an LLC (feels real)</li>
                            <li>- Create this /now page</li>
                        </ul><br></br>

                        My work at Sleeper has been good, and since leaving Apple my burnout recovery feels like it's around 80% now. I'm doing what I call "Itch Piloting"; working on being more present and whenever the Itch strikes for something like a game or Harbinger, I embrace it. The only discipline is fighting distraction and what I don't really want to spend my time on.<br></br><br></br>

                        My current game prototype that I'm spending 1 hour on every morning is Teas of the Kingdom, which I post updates to daily on <a className='league-p-clickable' href="https://bsky.app/profile/dendrobyte.bsky.social">BlueSky</a>. This morning practice has been incredibly helpful for getting away from the weight that is an obsession with "Result".<br></br><br></br>

                        This is a static page right now and easy enough to update since I set up the auto deploy via FTPxGitHub Actions when I did this a while ago. Hopefully my friends don't find it insensitive when I hit them with markobacon.com/now when they ask what I've been up to.
                    </p>
                </div>
            </div>
        </>
    )
}

export default Now;